module.exports = __webpack_public_path__ + "static/media/advisory_female.020bb6e5.svg";